import RestResource from '../rest.service';

export default class ProjectionStatesService extends RestResource {
  /*   getColors() {
    return ['warning', 'primary', 'success', 'danger', 'warning'];
  }
 */
  constructor() {
    super('projection-states');
  }
}
